// import React from "react";
import React, { useEffect } from "react";

const SOCIAL_PROVIDERS = [
  { icon: "fa-google", label: "Google", provider: "google" },
  { icon: "fa-microsoft", label: "Microsoft", provider: "microsoft" },
  { icon: "fa-facebook", label: "Facebook", provider: "facebook" },
  { icon: "fa-github", label: "GitHub", provider: "github" }
];

const SocialIcons = () => {

  return (
    <div className="social-icons">
      {SOCIAL_PROVIDERS.map(({ icon, label, provider }) => (
        <a key={icon} href="#" className="icon" id="HEG-social-icons-individuel" aria-label={`Se connecter avec ${label}`} onClick={(e) => {
          e.preventDefault();
        }}>
          <i className={`fa-brands ${icon}`}></i>
        </a>
      ))}
    </div>
  );
};

export default SocialIcons;
